import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { EventLog_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, unit_type, union_type, record_type, string_type, array_type, bool_type, option_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { some, unwrap, defaultArg, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { equalsWith, map as map_1, append } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { API_Route_Events } from "../Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { cons, ofArray, empty, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Route_fetchRouteEventLogs, mapFetchError } from "../Promises.js";
import { fromString } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { defaultOf, equals, createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { Skeleton, Button } from "@mui/material";
import Add from "@mui/icons-material/Add";
import { singleton as singleton_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { DeleteDialog_View_B0AE7AA, EditDialog_UpdateView_23A296DF, EditDialog_AddView_Z42F25CCA, Table_View_336D8DAB } from "../EventLogs.js";
import { ErrorHandling_snackError } from "../ViewHelpers.js";

class Model extends Record {
    constructor(Deleting, Editing, Events, ErrorMsg, Updating) {
        super();
        this.Deleting = Deleting;
        this.Editing = Editing;
        this.Events = Events;
        this.ErrorMsg = ErrorMsg;
        this.Updating = Updating;
    }
}

function Model_$reflection() {
    return record_type("RouteEventLog.Model", [], Model, () => [["Deleting", option_type(EventLog_$reflection())], ["Editing", bool_type], ["Events", option_type(array_type(EventLog_$reflection()))], ["ErrorMsg", option_type(string_type)], ["Updating", option_type(EventLog_$reflection())]]);
}

function init() {
    return new Model(undefined, false, undefined, undefined, undefined);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeletingSet", "EditingSet", "ErrorSet", "EventAdd", "EventRemove", "EventUpdate", "EventsResponse", "UpdatingSet"];
    }
}

function Message_$reflection() {
    return union_type("RouteEventLog.Message", [], Message, () => [[["Item", option_type(EventLog_$reflection())]], [["Item", bool_type]], [["Item", option_type(string_type)]], [["Item", EventLog_$reflection()]], [["Item", EventLog_$reflection()]], [["Item", EventLog_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(EventLog_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(EventLog_$reflection())]], [["ErrorValue", string_type]]])]], [["Item", option_type(EventLog_$reflection())]]]);
}

function update(model, msg) {
    let array;
    switch (msg.tag) {
        case 1:
            return new Model(model.Deleting, msg.fields[0], model.Events, model.ErrorMsg, model.Updating);
        case 2:
            return new Model(model.Deleting, model.Editing, model.Events, msg.fields[0], model.Updating);
        case 3:
            return new Model(model.Deleting, model.Editing, map((array = [msg.fields[0]], (array_1) => append(array, array_1)), model.Events), model.ErrorMsg, model.Updating);
        case 4:
            return new Model(model.Deleting, model.Editing, map((array_2) => array_2.filter((a) => (a.Id !== msg.fields[0].Id)), model.Events), model.ErrorMsg, model.Updating);
        case 5: {
            const updatedEventLog = msg.fields[0];
            return new Model(model.Deleting, model.Editing, map((array_3) => map_1((a_1) => {
                if ((a_1.Id < 0) ? true : (updatedEventLog.Id === a_1.Id)) {
                    return updatedEventLog;
                }
                else {
                    return a_1;
                }
            }, array_3), model.Events), model.ErrorMsg, model.Updating);
        }
        case 6: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                return new Model(model.Deleting, model.Editing, model.Events, res.fields[0], model.Updating);
            }
            else {
                return new Model(model.Deleting, model.Editing, res.fields[0], model.ErrorMsg, model.Updating);
            }
        }
        case 7: {
            const eventLogToUpdate = msg.fields[0];
            return new Model(model.Deleting, eventLogToUpdate != null, model.Events, model.ErrorMsg, eventLogToUpdate);
        }
        default:
            return new Model(msg.fields[0], model.Editing, model.Events, model.ErrorMsg, model.Updating);
    }
}

export function deleteEvent(routeId, eventLogToDeleteId, callback) {
    let properties_2;
    const url = API_Route_Events(routeId) + (`?id=${eventLogToDeleteId}`);
    let pr_2;
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(unit_type, undefined, undefined);
    const data_1 = "";
    const caseStrategy_2 = undefined;
    const extra_2 = undefined;
    try {
        const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(string_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(unit_type, unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => (Promise.resolve(new FSharpResult$2(0, [void undefined]))))))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    pr_2 = (pr_1.then(mapFetchError));
    return pr_2.then(callback);
}

export function postEvent(routeId, newEventLog, callback) {
    let properties_2;
    const objectUrl = API_Route_Events(routeId);
    let pr_2;
    let pr_1;
    const body = Auto_generateBoxedEncoder_437914C6(EventLog_$reflection(), undefined, undefined, undefined)(newEventLog);
    const decoder = Auto_generateBoxedDecoder_Z6670B51(EventLog_$reflection(), undefined, undefined);
    const data_1 = some(body);
    const caseStrategy_3 = undefined;
    const extra_3 = undefined;
    try {
        const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(objectUrl, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(EventLog_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    pr_2 = (pr_1.then(mapFetchError));
    return pr_2.then(callback);
}

export function putEvent(routeId, updatedEventLog, callback) {
    let properties_2;
    const url = API_Route_Events(routeId) + (`?id=${updatedEventLog.Id}`);
    let pr_2;
    let pr_1;
    const body = Auto_generateBoxedEncoder_437914C6(EventLog_$reflection(), undefined, undefined, undefined)(updatedEventLog);
    const decoder = Auto_generateBoxedDecoder_Z6670B51(EventLog_$reflection(), undefined, undefined);
    const data_1 = some(body);
    const caseStrategy_3 = undefined;
    const extra_3 = undefined;
    try {
        const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(EventLog_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    pr_2 = (pr_1.then(mapFetchError));
    return pr_2.then(callback);
}

export function View(viewInputProps) {
    let elems, props_1, elems_2;
    const routeId = viewInputProps.routeId;
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    useEffectOnce(() => {
        Route_fetchRouteEventLogs(routeId, (arg_2) => {
            dispatch(new Message(6, [arg_2]));
        });
    });
    const handleEditAccept = (eventLog$0027) => {
        if (eventLog$0027.Id < 0) {
            dispatch(new Message(3, [eventLog$0027]));
            const pr_1 = postEvent(routeId, eventLog$0027, (_arg_2) => {
                if (_arg_2.tag === 1) {
                    dispatch(new Message(4, [eventLog$0027]));
                    dispatch(new Message(2, [_arg_2.fields[0]]));
                }
                else {
                    dispatch(new Message(5, [_arg_2.fields[0]]));
                }
            });
            pr_1.then();
        }
        else {
            dispatch(new Message(5, [eventLog$0027]));
            const pr_2 = putEvent(routeId, eventLog$0027, (_arg_3) => {
                if (_arg_3.tag === 1) {
                    dispatch(new Message(2, [_arg_3.fields[0]]));
                }
                else {
                    dispatch(new Message(5, [_arg_3.fields[0]]));
                }
            });
            pr_2.then();
        }
        dispatch(new Message(7, [undefined]));
        dispatch(new Message(1, [false]));
    };
    const addEventButton = createElement("div", createObj(ofArray([["style", {
        paddingTop: 8,
        paddingBottom: 25,
    }], (elems = [MuiHelpers_createElement(Button, [["variant", "contained"], ["size", "medium"], ["startIcon", (props_1 = {}, react.createElement(Add, props_1))], ["onClick", (_arg_4) => {
        dispatch(new Message(1, [true]));
    }], ["children", "Legg til"]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        maxWidth: 1200,
    }], (elems_2 = toList(delay(() => append_1(singleton_1(addEventButton), delay(() => {
        let matchValue_1, testExpr, evs, elems_1;
        return append_1((matchValue_1 = model_1.Events, (matchValue_1 != null) ? (((testExpr = matchValue_1, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) ? singleton_1(createElement("p", {
            children: ["Ingen hendelser"],
        })) : ((evs = matchValue_1, singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "flex-start",
            width: 100 + "%",
        }], (elems_1 = [createElement(Table_View_336D8DAB, {
            events: evs,
            onUpdate: (arg_4) => {
                dispatch(new Message(7, [arg_4]));
            },
            onDelete: (arg_6) => {
                dispatch(new Message(0, [arg_6]));
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))))) : singleton_1(MuiHelpers_createElement(Skeleton, [["height", 100], ["variant", "rectangular"]]))), delay(() => append_1(singleton_1(createElement(EditDialog_AddView_Z42F25CCA, {
            isOpen: model_1.Editing,
            onAccept: handleEditAccept,
            onClose: () => {
                dispatch(new Message(1, [false]));
            },
        })), delay(() => append_1(singleton_1(createElement(EditDialog_UpdateView_23A296DF, {
            updating: unwrap(model_1.Updating),
            onAccept: handleEditAccept,
            onClose: () => {
                dispatch(new Message(7, [undefined]));
            },
        })), delay(() => append_1(singleton_1(createElement(DeleteDialog_View_B0AE7AA, {
            isOpen: model_1.Deleting != null,
            onDelete: () => {
                const matchValue = model_1.Deleting;
                if (matchValue == null) {
                }
                else {
                    const eventLogToDelete = matchValue;
                    dispatch(new Message(0, [undefined]));
                    const pr = deleteEvent(routeId, eventLogToDelete.Id, (_arg_1) => {
                        if (_arg_1.tag === 1) {
                            dispatch(new Message(2, [_arg_1.fields[0]]));
                        }
                        else {
                            dispatch(new Message(4, [eventLogToDelete]));
                        }
                    });
                    pr.then();
                }
            },
            onClose: () => {
                dispatch(new Message(0, [undefined]));
            },
        })), delay(() => singleton_1(ErrorHandling_snackError(model_1.ErrorMsg, () => {
            dispatch(new Message(2, [undefined]));
        }))))))))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

//# sourceMappingURL=RouteEventLog.js.map
